
var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};
const oneBoxVariants = {
  value: 1,
  ids: [
    '43974120997101', // red
    '43974380945645', // white
    '46439938425069', // rose
    '43416589074669' // bundle
  ]
}
const twoBoxVariants = {
  value: 2,
  ids: [
    '43974121029869', // red
    '43974380978413', // white
    '43974454739181', // rose
    '43416589107437' // bundle
  ]
}
const threeBoxVariants = {
  value: 3,
  ids: [
    '43974121062637', // red
    '43974381011181', // white
    '43974454771949', // rose
    '43416589140205' // bundle
  ]
}
const fourBoxVariants = {
  value: 4,
  ids: [
    '43974121095405', // red
    '43974381043949', // white
    '43974454804717', // rose
    '43416589172973' // bundle
  ]
}
function setupBundleSelector() {
  //window loaded?
  
  // Check URL for variant parameter and update it based on BoxVariants configuration
  const urlParams = new URLSearchParams(window.location.search);
  const variantParam = urlParams.get('variant');
  
  if (variantParam) {
    const allBoxVariants = [oneBoxVariants, twoBoxVariants, threeBoxVariants, fourBoxVariants];
    
    for (const boxVariant of allBoxVariants) {
      if (boxVariant.ids.includes(variantParam)) {
        // Update the URL parameter to use the boxVariant.value
        urlParams.set('variant', boxVariant.value);
        
        // Update the browser URL without reloading the page
        const newUrl = window.location.pathname + '?' + urlParams.toString()+"boxes";
        window.history.replaceState({}, '', newUrl);
        // // Update the selected variant button
        // const targetButton = document.querySelector(`.bundle-variant-button[data-index="${boxVariant.value}"]`);
        // if (targetButton) {
        //   // Remove selected class from all buttons
        //   document.querySelectorAll('.bundle-variant-button').forEach(btn => {
        //     btn.classList.remove('bundle-variant-button--selected');
        //   });
          
        //   // Add selected class to target button
        //   targetButton.classList.add('bundle-variant-button--selected');
          
        //   // Update the start quantity
        //   const bundleSelector = document.querySelector('.bundle-selector');
        //   if (bundleSelector) {
        //     bundleSelector.dataset.startQty = boxVariant.value;
        //   }
        // }
        break;
      }
    }
  }
  console.log("debugF: variantParam", variantParam);

  //window loaded?

  let startQty = document.querySelector('.bundle-selector').dataset.startQty;
  if(startQty > selectedBundles.length){
    // add more null bundles to selected bundles
    for(let i = selectedBundles.length; i < startQty; i++){
      selectedBundles.push(null)
    }
  }

  const selectedVar = document.querySelector('.bundle-variant-button--selected');

  if(selectedVar != null){
    updateSelectedBundles(selectedVar.dataset.index);
  }


  let qytBoxes = 0;
  if(variantParam == "1box" || variantParam == "1" || oneBoxVariants.ids.includes(variantParam)){
    // document.querySelector('.bundle-product-quantity-selector').dataset.quantity = 1;
    qytBoxes = 1;
  }else if(variantParam == "2boxes" || variantParam == "2" || twoBoxVariants.ids.includes(variantParam)){
    // document.querySelector('.bundle-product-quantity-selector').dataset.quantity = 2;
    qytBoxes = 2;
  }else if(variantParam == "3boxes" || variantParam == "3" || threeBoxVariants.ids.includes(variantParam)){
    // document.querySelector('.bundle-product-quantity-selector').dataset.quantity = 3;
    qytBoxes = 3;
  }else if(variantParam == "4boxes" || variantParam == "4" || fourBoxVariants.ids.includes(variantParam)){
    // document.querySelector('.bundle-product-quantity-selector').dataset.quantity = 4;
    qytBoxes = 4;
  }


  let preSelected = document.querySelectorAll('.bundle-product[data-preselected]');
  preSelected.forEach((product) => {
    const numberOfPreselections = Number(product.getAttribute('data-preselected'));
    if(numberOfPreselections) {
      console.log("debugF: numberOfPreselections", numberOfPreselections);
      for(var i = 0; i < qytBoxes; i++) {
        incrementProductQuantity(product);
      }
    } else {
      incrementProductQuantity(product);
    }
  });

  if(emptyBundles.length == 0){
    disableAddButtons();
  }

  let elComparisonToggle = document.querySelectorAll('[data-bundle-comparison-toggle]');
  elComparisonToggle.forEach(el => {
    el.addEventListener('click', (ev) => {
      let elComparison = ev.currentTarget.closest('[data-bundle-comparison]');
      let elPricing = elComparison.querySelector('[data-bundle-comparison-pricing]');

      elComparison.classList.toggle('open');
      elPricing.setAttribute('aria-hidden', elComparison.classList.contains('open'));
    })
  })

  document.querySelectorAll(".bundle-variant-button").forEach((button) => {
    button.addEventListener("click", () => {
      let subscribableRow = document.querySelector(".atc-row.subscribe-select");
      let firstRow = document.querySelector(".atc-row ");
      document
        .querySelectorAll(".bundle-variant-button")
        .forEach((otherButton) => {
          otherButton.classList.remove("bundle-variant-button--selected");
        });
      button.classList.add("bundle-variant-button--selected");
      let index = button.dataset.index;
      updateBoxCountCopy(index);
      if (index == 1) {
        subscribableRow.style.display = "none";
        firstRow.style.display = "none";
      } else {
        subscribableRow.style.display = "block";
        firstRow.style.display = "block";
      }

      updateSelectedBundles(index);
      renderBundleVisualization();

      document.querySelector(".bundle-product-visualizer").style.setProperty("--num-bundles", index);
      if (index == 1) updateSellingPlan();
      //console.log("qwe", index, button.dataset.price)
      updatePrices(index, button.dataset.price);

      /**
       * holiday 2024 add url parameter 
       */
      //setTimeout(refresh_espresso_cups,500)
      /**
       * END holiday 2024 add url parameter 
       */
    });
  });

  function addProductToBundle(productElement) {
    let rawBundleData = JSON.parse(
      productElement.querySelector(".bundle-product-raw").innerHTML
    );
    let index = selectedBundles.findIndex((bundle) => bundle == null);
    selectedBundles[index] = {
      id: productElement.dataset.productId,
      variant: productElement.dataset.variantId,
      icon: productElement.dataset.bundleImage,
      quantity: 1,
      sellingPlanGroups: rawBundleData.selling_plan_groups,
      variantSellingPlans: rawBundleData.variants.map((variant) => {
        return {
          id: variant.id,
          sellingPlans: variant.selling_plan_allocations,
        };
      }),
      serving: productElement.dataset.servingSize
    };
  }

  function incrementProductQuantity(productElement) {
    let quantitySelector = productElement.querySelector('.bundle-product-quantity-selector');
    let quantity = quantitySelector.dataset.quantity;
    
    if (quantity == 0) {
      quantitySelector.querySelector(
        ".bundle-quantity-minus"
      ).disabled = false;
    }

    quantity++;
    addProductToBundle(productElement);
    renderBundleVisualization();
    quantitySelector.dataset.quantity = quantity;
    quantitySelector.querySelector('.bundle-product-quantity').innerHTML = quantity;
  }

  function updateBoxCountCopy(count){
    let selectorClass = '.bundle__box-count';
    document.querySelectorAll(selectorClass).forEach(el => {
      el.innerHTML = count;
    })
  }

  document.querySelectorAll(".bundle-quantity-button").forEach((button) => {
    button.addEventListener("click", () => {
      let buttonParent = button.closest(".bundle-product-quantity-selector");
      let quantity = buttonParent.dataset.quantity;
      let isPlus = button.classList.contains("bundle-quantity-plus");
      //console.log("Empty Bundles", emptyBundles.length);
      let bundleProduct = button.closest(".bundle-product");

      const emptyText = buttonParent.querySelector(".bundle-product-quantity")
        .dataset.emptyText;

        
      if (isPlus) {
        if (quantity < selectedBundles.length && emptyBundles.length >= 1) {
          incrementProductQuantity(bundleProduct);
          if(emptyBundles.length ==0 ) {
            disableAddButtons();
          }
        } else if(emptyBundles.length == 0) {
          disableAddButtons();
          showMaxQtyError();
        }
      } else {
        decrementProductQuantity(bundleProduct);
      }
    });
  });

  document
    .querySelectorAll("input[type=radio][name=purchase_type]")
    .forEach((radio) => {
      radio.addEventListener("change", (ev) => {
        let selectedBundle = document.querySelector(
          ".bundle-variant-button--selected"
        );
        updatePrices(
          selectedBundle.dataset.index,
          selectedBundle.dataset.price
        );
        if (ev.target.id == "bundle-atc-subscription") {
          document
            .querySelector(".bundle-selling_plan_selector")
            .classList.add("bundle-selling_plan_selector--open");
        } else {
          document
            .querySelector(".bundle-selling_plan_selector")
            .classList.remove("bundle-selling_plan_selector--open");
        }
      });
    });
}

function showMaxQtyError() {
  const message = document.querySelector('.bundle-max-qty-error');
  message.style.display = 'flex';
  setTimeout(() => {
    message.style.opacity = 1;
  }, 50)
  setTimeout(hideMaxQtyError, 2000);
}

function hideMaxQtyError(){
  const message = document.querySelector('.bundle-max-qty-error');
  message.style.opacity = 0;
  setTimeout(() => {
    message.style.display = 'none';
  }, 500)
}

function disableAddButtons() {
  document.querySelectorAll(".bundle-quantity-plus").forEach((button) => {
    button.classList.add("bundle-quantity-plus--disabled");
  });
}

function enableAddButtons() {
  document.querySelectorAll(".bundle-quantity-plus").forEach((button) => {
    button.classList.remove('bundle-quantity-plus--disabled');
  });
}

function decrementProductQuantity(productElement) {
  const quantitySelector = productElement.querySelector('.bundle-product-quantity-selector');
  const quantityText = quantitySelector.querySelector('.bundle-product-quantity');
  const minusButton = quantitySelector.querySelector('.bundle-quantity-minus');
  const emptyText = quantityText.dataset.emptyText;
  let quantity = quantitySelector.dataset.quantity;

  if(quantity > 0) {
    quantity--;
    if (quantity == 0) {
      minusButton.disabled = true;
      quantityText.incrementProductQuantity = emptyText;
    }
    let index = selectedBundles.findLastIndex((bundle) => {
      return bundle === null
      ? false : bundle.variant == productElement.dataset.variantId;
    });
    selectedBundles[index] = null;
    renderBundleVisualization();
    enableAddButtons();
    quantitySelector.dataset.quantity = quantity;
    quantityText.innerHTML = quantity == 0 ? emptyText : quantity;
  }
}

function updateSellingPlan() {
  console.log("Updating selling plan!");
  let hasSellingPlan =
    document.querySelector(".bundle-selling_plan_selector--open") != null;

    if (hasSellingPlan && selectedBundles.length > 1) {
    let sellingPlanIndex = document.querySelector(
      "#bundle-selling_plan_select"
    ).value;
    selectedBundles = selectedBundles.map((product) => {
      let sellingplanGroupIndex = product.sellingPlanGroups.findIndex(
        (group) => group.app_id == "SKIO"
      );
      if (product == null) return;
      let sellingPlanId =
        product.sellingPlanGroups[sellingplanGroupIndex].selling_plans[
          sellingPlanIndex
        ].id;
      return {
        ...product,
        selling_plan: sellingPlanId,
      };
    });
  } else {
    if (selectedBundles.length == 1) {
      document
        .querySelector(".bundle-selling_plan_selector")
        .classList.remove("bundle-selling_plan_selector--open");
      document.getElementById("bundle-atc-onetime").checked = true;
    }

    selectedBundles = selectedBundles.map((product) => {
      if (product == null) return;
      return {
        ...product,
        selling_plan: null,
      };
    });
  }
}

document.querySelector("#bundle-atc").addEventListener("click", () => {
  insertSpinner('.minicart-empty_spinner',true)
  insertSpinner('.minicart-items')
   // document.querySelector("#bundle-atc").disabled = true
  let qty = selectedBundles.length;
  let isHoliday = document.querySelector('.bundle-selector').dataset.isHoliday == 'true';
  if (emptyBundles.length == 0) {
    updateSellingPlan();
    let products = selectedBundles;
    console.log(selectedBundles);
    let filteredProducts = [];
    selectedBundles.forEach((bundle) => {
      let index = filteredProducts.findIndex(
        (product) => product.id == bundle.id
      );
      if (index == -1) {
        filteredProducts.push(bundle);
      } else {
        filteredProducts[index].quantity++;
      }
    });

    let id = Date.now().toString().slice(0, 128);
    console.log("Filtered products", filteredProducts);

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        items: filteredProducts.map((product) => {
          return {
            id: product.variant,
            quantity: product.quantity,
            ...(!isHoliday && product.selling_plan && { selling_plan: product.selling_plan }),
            properties: {
              _isHoliday: isHoliday,
              _bundle: `${ isHoliday ? 'holiday_': '' }bundle_${id}`,
              _bundle_icon: product.icon,
              _selling_plan_groups: !isHoliday && product.sellingPlanGroups,
              _variant_selling_plans: !isHoliday && product.variantSellingPlans,
              _serving: product.serving
            },
          };
        }),
      }),
    })
      .then((res) => res.json())
      .then((res) => {
        console.log(res);
        selectedBundles = [null];
        updateSelectedBundles(qty);
        renderBundleVisualization();
        document.querySelector(".bundle-atc-error").style.display = "none";
        document.querySelector(".bundle-atc-error").innerHTML = "";
        resetQuantity();
        updateCart();
        openCart();
      })
      .then(res=>{
        document.querySelector("#bundle-atc").disabled = false
      });
  } else {
    console.log("Not all bundles are filled");
    document.querySelector(".bundle-atc-error").style.display = "flex";
    document.querySelector(".bundle-atc-error").innerHTML =
      `<svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M17.4381 13.7188L17.4383 13.7192C17.5996 13.9938 17.6852 14.3062 17.6867 14.6247C17.6881 14.9432 17.6053 15.2563 17.4465 15.5324C17.2878 15.8085 17.0588 16.0377 16.7828 16.1966C16.5068 16.3556 16.1937 16.4387 15.8753 16.4375H15.875H2.12503H2.12479C1.80632 16.4387 1.49321 16.3556 1.21724 16.1966C0.94128 16.0377 0.712297 15.8085 0.553547 15.5324C0.394797 15.2563 0.311934 14.9432 0.313373 14.6247C0.314812 14.3062 0.400501 13.9938 0.56174 13.7192L0.561945 13.7188L7.42913 1.8438L7.42919 1.84369C7.58812 1.56761 7.817 1.33829 8.09277 1.17884C8.36854 1.01938 8.68147 0.935425 9.00003 0.935425C9.31858 0.935425 9.63151 1.01938 9.90729 1.17884C10.1831 1.33829 10.4119 1.56761 10.5709 1.84369L10.5709 1.8438L17.4381 13.7188ZM8.51389 6.63887C8.38496 6.76781 8.31253 6.94267 8.31253 7.12501V10.25C8.31253 10.4323 8.38496 10.6072 8.51389 10.7361C8.64282 10.8651 8.81769 10.9375 9.00003 10.9375C9.18236 10.9375 9.35723 10.8651 9.48616 10.7361C9.6151 10.6072 9.68753 10.4323 9.68753 10.25V7.12501C9.68753 6.94267 9.6151 6.76781 9.48616 6.63887C9.35723 6.50994 9.18236 6.43751 9.00003 6.43751C8.81769 6.43751 8.64282 6.50994 8.51389 6.63887ZM8.44446 13.894C8.60891 14.0039 8.80225 14.0625 9.00003 14.0625C9.26524 14.0625 9.5196 13.9572 9.70713 13.7696C9.89467 13.5821 10 13.3277 10 13.0625C10 12.8647 9.94138 12.6714 9.8315 12.5069C9.72162 12.3425 9.56544 12.2143 9.38271 12.1386C9.19999 12.0629 8.99892 12.0431 8.80494 12.0817C8.61096 12.1203 8.43277 12.2156 8.29292 12.3554C8.15307 12.4953 8.05783 12.6734 8.01924 12.8674C7.98066 13.0614 8.00046 13.2625 8.07615 13.4452C8.15184 13.6279 8.28001 13.7841 8.44446 13.894Z" fill="black" stroke="#FBE8C0" stroke-width="0.125"/>
      </svg> Complete wine selection above`;
  }
});

function resetQuantity() {
  document
    .querySelectorAll(".bundle-product-quantity-selector")
    .forEach((button) => {
      const emptyText = button.querySelector(".bundle-product-quantity").dataset
        .emptyText;
      button.dataset.quantity = 0;
      button.querySelector(".bundle-product-quantity").innerHTML = emptyText;
    });
}

const EMPTY_BUNDLE = `
    <div class="empty-bundle">
      <svg width="115" height="153" viewBox="0 0 115 153" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M41.5894 0.00737476L41.4952 0L41.401 0.00685084L37.3769 0.299585C36.6883 0.349672 36.1708 0.948444 36.2209 1.63698C36.2709 2.32552 36.8697 2.84308 37.5583 2.793L40.4206 2.58478L40.3821 5.94249C40.3742 6.6328 40.9274 7.19883 41.6177 7.20675C42.308 7.21467 42.874 6.66149 42.8819 5.97118L42.9204 2.61931L45.7287 2.83931C46.417 2.89323 47.0186 2.379 47.0725 1.69075C47.1264 1.00251 46.6122 0.400863 45.924 0.346946L41.5894 0.00737476ZM32.1927 3.18331C32.8812 3.13322 33.3988 2.53445 33.3487 1.84591C33.2986 1.15738 32.6998 0.63981 32.0113 0.689897L23.963 1.27537C23.2744 1.32545 22.7569 1.92422 22.8069 2.61276C22.857 3.3013 23.4558 3.81886 24.1443 3.76878L32.1927 3.18331ZM51.7034 0.799708C51.0152 0.745791 50.4136 1.26002 50.3596 1.94826C50.3057 2.63651 50.8199 3.23815 51.5082 3.29207L60.1774 3.97122C60.8657 4.02513 61.4673 3.51091 61.5212 2.82266C61.5751 2.13441 61.0609 1.53277 60.3727 1.47885L51.7034 0.799708ZM18.7788 4.15909C19.4673 4.109 19.9849 3.51023 19.9348 2.82169C19.8847 2.13316 19.2859 1.61559 18.5974 1.66568L10.549 2.25115C9.86051 2.30123 9.34295 2.90001 9.39303 3.58854C9.44312 4.27708 10.0419 4.79464 10.7304 4.74456L18.7788 4.15909ZM66.1521 1.93161C65.4639 1.8777 64.8623 2.39192 64.8083 3.08017C64.7544 3.76842 65.2686 4.37006 65.9569 4.42398L74.6261 5.10312C75.3144 5.15704 75.916 4.64281 75.9699 3.95456C76.0238 3.26632 75.5096 2.66467 74.8214 2.61076L66.1521 1.93161ZM5.36487 5.13487C6.0534 5.08478 6.57097 4.48601 6.52088 3.79747C6.4708 3.10894 5.87202 2.59137 5.18349 2.64146L1.15931 2.93419L0 3.01853V4.1809V8.87767C0 9.56802 0.559644 10.1277 1.25 10.1277C1.94036 10.1277 2.5 9.56802 2.5 8.87767V5.34327L5.36487 5.13487ZM80.6008 3.06352C79.9126 3.0096 79.311 3.52383 79.257 4.21208C79.2031 4.90032 79.7173 5.50197 80.4056 5.55588L89.0748 6.23503C89.7631 6.28894 90.3647 5.77472 90.4186 5.08647C90.4725 4.39822 89.9583 3.79658 89.2701 3.74266L80.6008 3.06352ZM95.0495 4.19543C94.3613 4.14151 93.7597 4.65574 93.7057 5.34398C93.6518 6.03223 94.166 6.63387 94.8543 6.68779L103.524 7.36693C104.212 7.42085 104.813 6.90662 104.867 6.21838C104.921 5.53013 104.407 4.92849 103.719 4.87457L95.0495 4.19543ZM109.498 5.32733C108.81 5.27341 108.208 5.78764 108.154 6.47589C108.101 7.16413 108.615 7.76578 109.303 7.8197L112.485 8.06899V11.4212C112.485 12.1115 113.045 12.6712 113.735 12.6712C114.426 12.6712 114.985 12.1115 114.985 11.4212V6.91308V5.75718L113.833 5.6669L109.498 5.32733ZM2.5 15.14C2.5 14.4497 1.94036 13.89 1.25 13.89C0.559644 13.89 0 14.4497 0 15.14V24.5336C0 25.2239 0.559644 25.7836 1.25 25.7836C1.94036 25.7836 2.5 25.2239 2.5 24.5336V15.14ZM114.985 17.432C114.985 16.7416 114.426 16.182 113.735 16.182C113.045 16.182 112.485 16.7416 112.485 17.432V26.4482C112.485 27.1386 113.045 27.6982 113.735 27.6982C114.426 27.6982 114.985 27.1386 114.985 26.4482V17.432ZM2.5 30.7959C2.5 30.1056 1.94036 29.5459 1.25 29.5459C0.559644 29.5459 0 30.1056 0 30.7959V40.1895C0 40.8798 0.559644 41.4395 1.25 41.4395C1.94036 41.4395 2.5 40.8798 2.5 40.1895V30.7959ZM114.985 32.459C114.985 31.7687 114.426 31.209 113.735 31.209C113.045 31.209 112.485 31.7687 112.485 32.459V41.4752C112.485 42.1656 113.045 42.7252 113.735 42.7252C114.426 42.7252 114.985 42.1656 114.985 41.4752V32.459ZM2.5 46.4518C2.5 45.7615 1.94036 45.2018 1.25 45.2018C0.559644 45.2018 0 45.7615 0 46.4518V55.8453C0 56.5357 0.559644 57.0953 1.25 57.0953C1.94036 57.0953 2.5 56.5357 2.5 55.8453V46.4518ZM114.985 47.486C114.985 46.7957 114.426 46.236 113.735 46.236C113.045 46.236 112.485 46.7957 112.485 47.486V56.5023C112.485 57.1926 113.045 57.7523 113.735 57.7523C114.426 57.7523 114.985 57.1926 114.985 56.5023V47.486ZM2.5 62.1077C2.5 61.4173 1.94036 60.8577 1.25 60.8577C0.559644 60.8577 0 61.4173 0 62.1077V71.5012C0 72.1916 0.559644 72.7512 1.25 72.7512C1.94036 72.7512 2.5 72.1916 2.5 71.5012V62.1077ZM114.985 62.5131C114.985 61.8227 114.426 61.2631 113.735 61.2631C113.045 61.2631 112.485 61.8227 112.485 62.5131V71.5293C112.485 72.2196 113.045 72.7793 113.735 72.7793C114.426 72.7793 114.985 72.2196 114.985 71.5293V62.5131ZM114.985 77.5401C114.985 76.8497 114.426 76.2901 113.735 76.2901C113.045 76.2901 112.485 76.8497 112.485 77.5401V86.5563C112.485 87.2467 113.045 87.8063 113.735 87.8063C114.426 87.8063 114.985 87.2467 114.985 86.5563V77.5401ZM2.5 77.7636C2.5 77.0732 1.94036 76.5136 1.25 76.5136C0.559644 76.5136 0 77.0732 0 77.7636V87.1571C0 87.8475 0.559644 88.4071 1.25 88.4071C1.94036 88.4071 2.5 87.8475 2.5 87.1571V77.7636ZM114.985 92.5671C114.985 91.8768 114.426 91.3171 113.735 91.3171C113.045 91.3171 112.485 91.8768 112.485 92.5671V101.583C112.485 102.274 113.045 102.833 113.735 102.833C114.426 102.833 114.985 102.274 114.985 101.583V92.5671ZM2.5 93.4195C2.5 92.7291 1.94036 92.1695 1.25 92.1695C0.559644 92.1695 0 92.7291 0 93.4195V102.813C0 103.503 0.559644 104.063 1.25 104.063C1.94036 104.063 2.5 103.503 2.5 102.813V93.4195ZM114.985 107.594C114.985 106.904 114.426 106.344 113.735 106.344C113.045 106.344 112.485 106.904 112.485 107.594V116.61C112.485 117.301 113.045 117.86 113.735 117.86C114.426 117.86 114.985 117.301 114.985 116.61V107.594ZM2.5 109.075C2.5 108.385 1.94036 107.825 1.25 107.825C0.559644 107.825 0 108.385 0 109.075V118.469C0 119.159 0.559644 119.719 1.25 119.719C1.94036 119.719 2.5 119.159 2.5 118.469V109.075ZM114.985 122.621C114.985 121.931 114.426 121.371 113.735 121.371C113.045 121.371 112.485 121.931 112.485 122.621V131.637C112.485 132.328 113.045 132.887 113.735 132.887C114.426 132.887 114.985 132.328 114.985 131.637V122.621ZM2.5 124.731C2.5 124.041 1.94036 123.481 1.25 123.481C0.559644 123.481 0 124.041 0 124.731V134.125C0 134.815 0.559644 135.375 1.25 135.375C1.94036 135.375 2.5 134.815 2.5 134.125V124.731ZM114.985 137.648C114.985 136.958 114.426 136.398 113.735 136.398C113.045 136.398 112.485 136.958 112.485 137.648V141.057L109.137 141.49C108.452 141.579 107.969 142.206 108.057 142.89C108.146 143.575 108.773 144.058 109.457 143.97L113.896 143.396L114.985 143.255V142.156V137.648ZM2.5 140.387C2.5 139.697 1.94036 139.137 1.25 139.137C0.559644 139.137 0 139.697 0 140.387V145.084V146.137L1.03779 146.316L4.8895 146.979C5.56983 147.097 6.21636 146.64 6.33356 145.96C6.45077 145.279 5.99426 144.633 5.31392 144.516L2.5 144.031V140.387ZM103.54 144.735C104.225 144.646 104.708 144.019 104.619 143.335C104.531 142.65 103.904 142.167 103.219 142.255L94.3432 143.403C93.6586 143.492 93.1753 144.118 93.2638 144.803C93.3523 145.488 93.9791 145.971 94.6638 145.882L103.54 144.735ZM88.7463 146.647C89.431 146.559 89.9143 145.932 89.8257 145.247C89.7372 144.563 89.1104 144.079 88.4258 144.168L79.5496 145.316C78.865 145.404 78.3817 146.031 78.4702 146.716C78.5587 147.4 79.1855 147.883 79.8702 147.795L88.7463 146.647ZM10.4495 145.4C9.7692 145.283 9.12267 145.74 9.00547 146.42C8.88827 147.1 9.34478 147.747 10.0251 147.864L17.7285 149.191C18.4089 149.308 19.0554 148.852 19.1726 148.171C19.2898 147.491 18.8333 146.845 18.153 146.727L10.4495 145.4ZM73.9527 148.56C74.6374 148.471 75.1206 147.845 75.0321 147.16C74.9436 146.475 74.3168 145.992 73.6322 146.081L64.756 147.228C64.0713 147.317 63.5881 147.943 63.6766 148.628C63.7651 149.313 64.3919 149.796 65.0765 149.708L73.9527 148.56ZM23.2886 147.612C22.6082 147.495 21.9617 147.951 21.8445 148.632C21.7273 149.312 22.1838 149.959 22.8641 150.076L30.5676 151.403C31.2479 151.52 31.8944 151.064 32.0116 150.383C32.1288 149.703 31.6723 149.056 30.992 148.939L23.2886 147.612ZM59.1591 150.473C59.8437 150.384 60.327 149.757 60.2385 149.073C60.15 148.388 59.5232 147.905 58.8385 147.993L49.9624 149.141C49.2777 149.229 48.7944 149.856 48.8829 150.541C48.9715 151.225 49.5982 151.709 50.2829 151.62L59.1591 150.473ZM36.1276 149.824C35.4473 149.707 34.8007 150.163 34.6835 150.844C34.5663 151.524 35.0228 152.17 35.7032 152.288L39.5549 152.951L39.7405 152.983L39.8713 152.966C39.8956 152.968 39.9201 152.969 39.9448 152.969C40.091 152.971 40.2317 152.947 40.3626 152.903L44.3655 152.385C45.0501 152.297 45.5334 151.67 45.4449 150.985C45.3563 150.301 44.7296 149.817 44.0449 149.906L41.2258 150.27L41.2608 147.225C41.2687 146.535 40.7155 145.969 40.0252 145.961C39.3349 145.953 38.7688 146.506 38.7609 147.197L38.7256 150.271L36.1276 149.824ZM42.8129 11.982C42.8209 11.2917 42.2677 10.7257 41.5774 10.7177C40.8871 10.7098 40.321 11.263 40.3131 11.9533L40.2096 20.9695C40.2017 21.6599 40.7549 22.2259 41.4452 22.2338C42.1355 22.2417 42.7015 21.6885 42.7095 20.9982L42.8129 11.982ZM42.6405 27.0091C42.6484 26.3187 42.0952 25.7527 41.4049 25.7448C40.7146 25.7369 40.1486 26.2901 40.1406 26.9804L40.0372 35.9966C40.0292 36.6869 40.5824 37.2529 41.2727 37.2609C41.963 37.2688 42.5291 36.7156 42.537 36.0253L42.6405 27.0091ZM42.468 42.0361C42.4759 41.3458 41.9228 40.7798 41.2324 40.7718C40.5421 40.7639 39.9761 41.3171 39.9682 42.0074L39.8647 51.0237C39.8568 51.714 40.41 52.28 41.1003 52.2879C41.7906 52.2958 42.3566 51.7427 42.3645 51.0523L42.468 42.0361ZM42.2955 57.0632C42.3035 56.3729 41.7503 55.8068 41.06 55.7989C40.3697 55.791 39.8036 56.3442 39.7957 57.0345L39.6922 66.0507C39.6843 66.741 40.2375 67.3071 40.9278 67.315C41.6181 67.3229 42.1841 66.7697 42.1921 66.0794L42.2955 57.0632ZM42.1231 72.0902C42.131 71.3999 41.5778 70.8339 40.8875 70.826C40.1972 70.818 39.6312 71.3712 39.6232 72.0615L39.5198 81.0778C39.5118 81.7681 40.065 82.3341 40.7553 82.342C41.4457 82.35 42.0117 81.7968 42.0196 81.1065L42.1231 72.0902ZM41.9506 87.1173C41.9585 86.427 41.4054 85.8609 40.715 85.853C40.0247 85.8451 39.4587 86.3983 39.4508 87.0886L39.3473 96.1048C39.3394 96.7951 39.8926 97.3612 40.5829 97.3691C41.2732 97.377 41.8392 96.8238 41.8471 96.1335L41.9506 87.1173ZM41.7782 102.144C41.7861 101.454 41.2329 100.888 40.5426 100.88C39.8523 100.872 39.2862 101.425 39.2783 102.116L39.1748 111.132C39.1669 111.822 39.7201 112.388 40.4104 112.396C41.1007 112.404 41.6668 111.851 41.6747 111.161L41.7782 102.144ZM41.6057 117.171C41.6136 116.481 41.0604 115.915 40.3701 115.907C39.6798 115.899 39.1138 116.452 39.1059 117.143L39.0024 126.159C38.9945 126.849 39.5476 127.415 40.2379 127.423C40.9283 127.431 41.4943 126.878 41.5022 126.188L41.6057 117.171ZM41.4332 132.198C41.4412 131.508 40.888 130.942 40.1977 130.934C39.5073 130.926 38.9413 131.479 38.9334 132.17L38.8299 141.186C38.822 141.876 39.3752 142.442 40.0655 142.45C40.7558 142.458 41.3218 141.905 41.3298 141.215L41.4332 132.198Z" fill="#D9D9D9"/>
      </svg>
    </div>
`;

let selectedBundles = [null, null];
let emptyBundles = document.querySelectorAll(".empty-bundle");

function updateSelectedBundles(idx) {
  const index = parseInt(idx)
  if (index >= selectedBundles.length) {
    for (let i = selectedBundles.length; i < index; i++) {
      selectedBundles.push(null);
    }
      enableAddButtons();

  } else {
    console.log("Here", { index, lenght: selectedBundles.length, isILarger: selectedBundles.length > index })
    for(let i = selectedBundles.length; i > index; i--){
      let arrayIdx = i - 1;
      if(selectedBundles[arrayIdx] != null){
        console.log("Update Item ", { item: selectedBundles[arrayIdx] });
        let qtyElement = document.querySelector(`[data-product-id="${selectedBundles[arrayIdx].id}"]`);
        decrementProductQuantity(qtyElement);
      }
    }
    selectedBundles = selectedBundles.slice(0, index);
    //update empty bundles number
    hasNull = selectedBundles.some(bundle => bundle == null);

    console.log({ sel: selectedBundles.length, empt: hasNull, index }, "emp Disable add buttons")
    if(!hasNull && index == selectedBundles.length){
      disableAddButtons();
    }
  }
}

function renderBundleVisualization() {
  let bundleContainer = document.querySelector(".bundle-product-visualizer");
  let updatedHTML = `
        ${selectedBundles
          .map((bundle) => {
            if (bundle != null) {
              return `<div class="full-bundle">
                    <img src="${bundle.icon}" width="115" alt="Bundle Icon">
                </div>`;
            } else {
              return EMPTY_BUNDLE;
            }
          })
          .join("")}
    `;
  bundleContainer.innerHTML = updatedHTML;
  emptyBundles = document.querySelectorAll(".empty-bundle");
}

function updatePrices(quantity, box_price) {
  let price = parseInt(quantity) * parseInt(box_price);
  var formattedPrice = Shopify.formatMoney(price.toString(), "${{amount}}");

  let one_time_radio = document.querySelector("#bundle-atc-onetime");
  let isSub = one_time_radio.checked == false;

  let one_time_atc = document.querySelector(".bundle-atc-price.bundle-onetime");
  let sub_atc = document.querySelector(".bundle-atc-price.bundle-subscription");
  let sub_compareat = document.querySelector(".bundle-subscription-compareat");
  let atc_price = document.querySelector("#bundle-atc .atc-price");
  let atc_message = document.querySelector(".atc-message");

  one_time_atc.innerHTML = formattedPrice;
  sub_compareat.innerHTML = formattedPrice;

  let subPrice = Math.round(price - quantity * 500);

  var formattedSubPrice = Shopify.formatMoney(
      subPrice.toString(),
      "${{amount}}"
    );
  sub_atc.innerHTML = formattedSubPrice;
  if (isSub) {
    atc_price.innerHTML = formattedSubPrice;
    atc_message.innerHTML = "Subscribe";
  } else {
    atc_price.innerHTML = formattedPrice;
    atc_message.innerHTML = "Add to cart";
  }
}

// window.addEventListener('DOMContentLoaded', setupBundleSelector);

setupBundleSelector();

// $(document).ready(function(){
//   setupBundleSelector();
// })
